var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 269,
    viewBox: "0 0 251 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1909 237.658L110.895 168.368L113.491 165.588V169.392V267.287H137.509V169.392V165.588L140.105 168.368L204.809 237.658L221.93 219.323L157.086 149.883L154.729 147.36H158.182H249.5V121.428H158.182H154.729L157.086 118.904L221.93 49.4644L204.809 31.1297L140.105 100.419L137.509 103.199V99.3953V1.5H113.491V99.3953V103.199L110.895 100.419L46.1909 31.1297L29.0697 49.4644L93.914 118.904L96.2708 121.428H92.8177H1.49998V147.36H92.8177H96.2708L93.914 149.883L29.0697 219.323L46.1909 237.658Z",
    fill: "#E0410E",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/OrangeStar.7fa89a3d23aa99be40c84f8b13f3ee58.svg";
export { ForwardRef as ReactComponent };